import { observer } from "mobx-react-lite";
import { XStack } from "tamagui";
import type { PlanTag, PlanTagWithOptions } from "../../plans/PlanModel";
import { TagPill } from "./TagPill";

export const TagsCloud = observer(
  ({
    tags,
    onPress,
  }: {
    tags: PlanTagWithOptions[];
    onPress?: (tag: PlanTag) => void;
  }) => {
    return (
      <XStack gap="$medium" flexWrap="wrap">
        {tags.map((tag) => (
          <TagPill
            key={tag.uid}
            tag={tag}
            onPress={() => {
              onPress?.(tag);
            }}
          />
        ))}
      </XStack>
    );
  },
);
